import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import { Button, Modal, ModalProps } from 'antd';

import { CheckOutlined } from '@ant-design/icons';
import { ColumnsType } from 'antd/lib/table';
import { useIntl } from 'react-intl';
import LoadMoreSummary from '@/components/_common/LoadMoreSummary';
import { useState } from 'react';
import { ListSuppliersQuery } from '@/core/domain/people/Suppliers/Suppliers.types';
import { COLUMNS_WIDTH, getTableScrollX } from '@/utils/table';
import { InfiniteTable } from '@/components/_common';
import { useRouteMatch } from 'react-router-dom';
import { useTasks } from '@/core/domain/operational/Tasks/Tasks.hooks';
import { Task } from '@/core/domain/operational/Tasks/Tasks.types';
import SelectServiceReplacementFilters from '../SelectServiceReplacementFilters';
import { useDebounce } from '@/hooks';

interface Props extends ModalProps {
  onCancel: VoidFunction;
  handlerServiceSelect?: (service: Task) => void;
}

const SelectServiceReplacementModal = ({
  open,
  onCancel,
  onOk,
  handlerServiceSelect,
}: Props) => {
  const intl = useIntl().formatMessage;

  const [queryParams, setQueryParams] = useState<ListSuppliersQuery>({
    order: 'ASC',
  });

  const queryDebounce = useDebounce(queryParams);

  const { taskId } = useRouteMatch<{ taskId: string }>().params;
  const { data, isFetching, hasNextPage, fetchNextPage } =
    useTasks(queryDebounce);

  const tasks = flatInfiniteData(data);

  const columns: ColumnsType<Task> = [
    {
      key: 'temparioCode',
      dataIndex: 'temparioCode',
      title: intl({ id: 'tasks.general.form.temporaryCode' }),
      ellipsis: true,
      width: 300,
    },
    {
      key: 'description',
      dataIndex: 'description',
      title: intl({ id: 'tasks.general.form.description' }),
      ellipsis: true,
      width: 300,
    },
    {
      key: 'subArea',
      dataIndex: ['subArea', 'name'],
      title: intl({ id: 'tasks.general.form.area' }),
      ellipsis: true,
      width: 200,
    },
    handlerServiceSelect
      ? {
          key: 'action',
          dataIndex: 'action',
          width: COLUMNS_WIDTH.default,
          align: 'right',
          render: (_, item) => (
            <Button
              type="primary"
              onClick={() => handlerServiceSelect(item)}
              icon={<CheckOutlined />}
            />
          ),
        }
      : {},
  ];

  return (
    <Modal
      title="Selecionar Serviço"
      open={open}
      onOk={onOk}
      onCancel={() => {
        setQueryParams({});
        onCancel();
      }}
      width="90%"
      destroyOnClose
    >
      <SelectServiceReplacementFilters setQueryParams={setQueryParams} />

      <InfiniteTable
        dataSource={tasks.filter((task) => task.id !== +taskId)}
        scroll={{ x: getTableScrollX(columns) }}
        columns={columns}
        pagination={false}
        loading={isFetching}
        summary={() =>
          hasNextPage ? (
            <LoadMoreSummary
              onClick={fetchNextPage}
              columnsCount={columns.length}
            />
          ) : null
        }
      />
    </Modal>
  );
};

export default SelectServiceReplacementModal;
